import { render, staticRenderFns } from "./ModalUnitEdit.vue?vue&type=template&id=65c98f97&scoped=true"
import script from "./ModalUnitEdit.vue?vue&type=script&lang=js"
export * from "./ModalUnitEdit.vue?vue&type=script&lang=js"
import style0 from "./ModalUnitEdit.vue?vue&type=style&index=0&id=65c98f97&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c98f97",
  null
  
)

export default component.exports